/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:09/01/2021
 @Time:20:17
 **/
require ("jquery-datetimepicker/build/jquery.datetimepicker.full");
//configuration générale pour tous champ input qui est le fils directe d'un div ayant la classe date ou time
$(document).ready(function()
{
    jQuery.datetimepicker.setLocale(locale.split('_')[0]);
});